var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"emerge-page"}},[_c('LandingBanner'),_c('InfoAlliances'),_c('Emerge'),_c('HowItWorks'),_c('EmergeGoals'),_c('AboutAlliance'),_c('OportunityDescription'),_c('EmergeEnd')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }